webpackJsonp([137459750979060],{

/***/ 1084:
/***/ (function(module, exports) {

	module.exports = {"data":{"cardsJson":{"starting_zone":"codex","mid_text_1":null,"sirlins_filename":"0025_nimble_fencer.jpg","type":"Unit","subtype":"Virtuoso","cost":2,"ATK":2,"HP":3,"rules_text_1":"Your virtuosos have haste. (Can attack and ⤵ the turn they arrive.)","rules_text_2":null,"rules_text_3":null,"base_text_1":null,"base_text_2":null,"ATK_1":null,"HP_1":null,"mid_level":null,"name":"Nimble Fencer","mid_text_2":null,"ATK_2":null,"HP_2":null,"max_level":null,"max_text_1":null,"max_text_2":null,"ATK_3":null,"HP_3":null,"flavor_text":"\"En Garde!\"","color":"Neutral","spec":"Finesse","bottom":"Tech I","rulings":[{"ruling":"Nimble Fencer herself is a Virtuoso, so her ability grants herself haste.","date":"2016-03-04T08:00:00.000Z","author":"Sirlin"}],"keywords":["Haste"],"slug":"nimble_fencer"},"site":{"siteMetadata":{"title":"Codex Card Database"}}},"pathContext":{"slug":"nimble_fencer","keywords":["Haste"],"imageRegex":"/nimble_fencer.jpg/"}}

/***/ })

});


// WEBPACK FOOTER //
// path---card-nimble-fencer-5c9eb8d2d48656f8b42c.js